import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import React from 'react';
import { useInput } from 'react-admin';

const ADDON_GROUPS = [
  {
    tier: 'free',
    title: 'Suite Add-ons (Included)',
  },
  {
    tier: 'premium',
    title: 'Premium Enhancements (Additional charge)',
  },
];

const renderChoiceLabel = choice => (
  <span className={choice.disabled ? 'text-gray-400' : ''}>
    <span>{choice.name}</span>
    <span
      className={`appointment-addon-price ml-2 ${
        choice.tier === 'free' ? 'text-gray-500' : 'font-medium'
      }`}
    >
      {choice.priceLabel}
    </span>
  </span>
);

export const AppointmentAddonCheckboxGroup = ({
  source,
  label,
  choices = [],
  onSelectionChange,
}) => {
  const {
    input: { value, onChange },
  } = useInput({ source });

  const selectedIds = Array.isArray(value) ? value : [];

  const handleToggle = (choiceId, disabled) => {
    if (disabled) return;

    const next = selectedIds.includes(choiceId)
      ? selectedIds.filter(id => id !== choiceId)
      : [...selectedIds, choiceId];

    onChange(next);
    onSelectionChange?.(next);
  };

  const groupedChoices = ADDON_GROUPS.map(group => ({
    ...group,
    items: choices.filter(choice => choice.tier === group.tier),
  })).filter(group => group.items.length > 0);

  return (
    <FormGroup className="appointment-addon-checkbox-group">
      {label && (
        <FormLabel component="legend" className="mb-2">
          {label}
        </FormLabel>
      )}
      {groupedChoices.map(group => (
        <div key={group.tier} className="appointment-addon-group mb-3">
          <FormLabel
            component="legend"
            className="text-sm font-semibold mb-1 block"
          >
            {group.title}
          </FormLabel>
          {group.items.map(choice => (
            <FormControlLabel
              key={choice.id}
              disabled={choice.disabled}
              title={choice.disabled ? choice.disabledReason || '' : ''}
              control={
                <Checkbox
                  color="primary"
                  checked={selectedIds.includes(choice.id)}
                  disabled={choice.disabled}
                  onChange={() => handleToggle(choice.id, choice.disabled)}
                />
              }
              label={renderChoiceLabel(choice)}
            />
          ))}
        </div>
      ))}
    </FormGroup>
  );
};
